import 'arrive';
import $ from 'jquery';

document.arrive('.btn-show-video-modal', {existing: true}, function() {
    let prevScroll = 0;
    let modalId = $(this).data('target');

    $(modalId).on('show.bs.modal', function(){
        prevScroll = $(window).scrollTop();
        $('body')
            .css('height', 'auto')
            .css('overflow-y', 'auto');
        $('html')
            .css('height', '100vh')
            .css('overflow-y', 'hidden');
    }).on('hide.bs.modal', function(){
        $('html')
            .css('height', 'auto')
            .css('overflow-y', 'auto');
    })

    $(modalId).on('show.bs.modal', function(){
        $(this).find('video source').attr('src', $(this).find('source').data('video'));
        $(this).find('video')[0].load();
    });

});
